/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Conflict_TitleInputs */



/**
* | output |
* | --- |
* | "Shortcut already in use" |
*
* @param {Shortcut_Keys_Conflict_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_conflict_title = /** @type {((inputs?: Shortcut_Keys_Conflict_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Conflict_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Raccourci déjà utilisé")
	if (locale === "de") return /** @type {LocalizedString} */ ("Tastenkombination bereits vergeben")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scorciatoia già in uso")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сочетание клавиш уже используется")
	if (locale === "es") return /** @type {LocalizedString} */ ("El atajo ya está en uso")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("快捷键已被使用")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ショートカットはすでに使用されています")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शॉर्टकट पहले से उपयोग में है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atalho já em uso")
	return /** @type {LocalizedString} */ ("Shortcut already in use")
});